import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fwetqwufaosetevfkhkp.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_MtTwM0l8Ssb7PsnGPKiVIg_9bISH4ao'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
